import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/nextjs';
import { getSetupIntent } from 'services/client/stripe/getSetupIntent';

/** The SetupIntent a PaymentElement mounts on; the card is saved before the server charges it. */
export const useStripeSetupIntent = () => {
  const [clientSecret, setClientSecret] = useState<string>();
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    let active = true;
    getSetupIntent()
      .then((res) => {
        if (active) setClientSecret(res.setupIntentClientSecret);
      })
      .catch((error) => {
        Sentry.captureException(error);
        if (active) setLoadFailed(true);
      });
    return () => {
      active = false;
    };
  }, []);

  return { clientSecret, loadFailed };
};
